var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { enhancerRightStyle } from './styles';
function EnhancerRight(_a) {
    var size = _a.size, inverted = _a.inverted, children = _a.children;
    return _jsx("div", __assign({ css: enhancerRightStyle({ size: size, inverted: inverted }) }, { children: children }));
}
export default EnhancerRight;
